// extracted by mini-css-extract-plugin
export default {"displayText":"contact_displayText__wah2R","loadingOverlay":"contact_loadingOverlay__nYPYF"};